export default "<div [dir]=\"direction\">\r\n    <router-outlet></router-outlet>\r\n</div>"